import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ClinicalFocus from '../components/ClinicalFocus';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ServicesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      {/* Hero Section */}
      <div className="relative pt-32 pb-16 px-4" style={{ background: 'linear-gradient(135deg, #053827 0%, #0a5a40 100%)' }}>
        <div className="container mx-auto max-w-6xl">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="mb-6 text-white border-white hover:bg-white/20"
          >
            <ArrowLeft className="mr-2" size={16} />
            {t('backToHome')}
          </Button>

          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('services.title')}
            </h1>
            <p className="text-xl text-emerald-100 max-w-3xl mx-auto">
              {t('comprehensiveServices')}
            </p>
          </div>
        </div>
      </div>

      {/* Services Grid */}
      <div className="py-8">
        <ClinicalFocus />
      </div>

      <Footer />
    </div>
  );
};

export default ServicesPage;
